export default __webpack_public_path__ + "static/media/f21.73578916.png";